
export default {
  i18nComponentKey: 'ReviewsNew.components.ReviewFormConsentItemsSection',
  name: 'ReviewFormConsentItemsSection',
  model: {
    prop: 'checkedConsentIds',
    event: 'change'
  },
  props: {
    consentItems: { type: Array, required: true },
    checkedConsentIds: { type: Array, default: () => [] },
    accentColor: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    changeCheckedConsentIds(item) {
      const isChecked = this.checkedConsentIds.includes(item.id);
      const nextCheckedIds = isChecked
        ? this.checkedConsentIds.filter(id => id !== item.id)
        : [...this.checkedConsentIds, item.id];
      const changed = this.consentItems
        .filter(consentItem => nextCheckedIds.includes(consentItem.id))
        .map(consentItem => consentItem.id);
      this.$emit('change', changed);
    }
  }
};
